var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIcPickingReporte = function SvgIcPickingReporte(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 18,
    viewBox: "0 0 14 18",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.66665 0.666687H1.99998C1.55795 0.666687 1.13403 0.842282 0.821468 1.15484C0.508908 1.4674 0.333313 1.89133 0.333313 2.33335V15.6667C0.333313 16.1087 0.508908 16.5326 0.821468 16.8452C1.13403 17.1578 1.55795 17.3334 1.99998 17.3334H12C12.442 17.3334 12.8659 17.1578 13.1785 16.8452C13.491 16.5326 13.6666 16.1087 13.6666 15.6667V5.66669L8.66665 0.666687ZM12 15.6667H1.99998V2.33335H7.83331V6.50002H12V15.6667Z",
    fill: "current"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcPickingReporte, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ic_picking_reporte.dbcfd3d5.svg";
export { ForwardRef as ReactComponent };